import { makeStyles } from "@material-ui/styles";

const teamDetailsStyles = makeStyles((theme) => ({
	contentContainer: {
		height: "100%"
	},
	logo: {
		width: ({ hasLogo }) => `${hasLogo ? "200" : "150"}px !important`,
		height: "150px !important",
		fontSize: theme.spacing(4),
		fontWeight: "bold",
		color: theme.palette.menu.backgroundColor,
		"& img": {
			objectFit: "contain"
		},
		margin: "auto"
	},
	detailsContainer: {
		margin: "auto",
		display: "flex",
		[theme.breakpoints.down("xs")]: {
			padding: theme.spacing(0)
		},
		[theme.breakpoints.up("sm")]: {
			padding: theme.spacing(4)
		},
		[theme.breakpoints.down("sm")]: {
			alignItems: "flex-start"
		},
		maxHeight: 650
	},
	colorContainer: {
		display: "flex",
		maxWidth: "100%",
		"& button": {
			width: theme.spacing(7),
			height: theme.spacing(7),
			margin: theme.spacing(0, 0, 0, 1)
		},
		"& button:hover": {
			backgroundColor: ({ teamColor }) => teamColor,
			"& div": {
				backgroundColor: "transparent"
			}
		}
	}
}));

export default teamDetailsStyles;
